import {
  Component,
  EventEmitter,
  inject,
  InjectionToken,
  Input,
  Output,
} from '@angular/core';
import { ExpenseUpdateModalHeader } from '../../expense-header.model';
import { TranslateModule } from '@ngx-translate/core';
import { FormsModule } from '@angular/forms';
import {
  CustomDataBaseModel,
  CustomDataContentService,
  ExpenseEventType,
  ExpenseModel,
  ObjectDefinitionHelpers,
  ObjectDefinitionModel,
  SearchOperators,
} from '@seahorse/domain';
import { CommonModule } from '@angular/common';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { EventModel, ResultStatus } from '@seahorse/common';

export const EXPENSE_CREATE_MODAL = new InjectionToken<any>(
  'Expense Create Modal'
);

@Component({
  selector: 'temp-expense-action-header',
  template: `
    <div class="input-group">
      <button class="btn btn-primary btn-sm" (click)="openExpenseDialog()">
        <i class="fa-regular fa-plus fa-fw"></i>
        {{ 'shared.terms.add' | translate }}
        {{ 'customModules.expenses' | translate }}
      </button>
    </div>
  `,
  standalone: true,
  imports: [CommonModule, FormsModule, TranslateModule],
})
export class ExpenseActionHeaderComponent implements ExpenseUpdateModalHeader {
  private _exprenseCreateModal = inject(EXPENSE_CREATE_MODAL);
  private _customDataContentService = inject(CustomDataContentService);
  private _objectDefinitionHelpers = inject(ObjectDefinitionHelpers);
  private _modal = inject(NgbModal);

  // interface implementation
  @Input() isLoading = false;
  @Input() parent: CustomDataBaseModel;
  @Input() parentDefinition: ObjectDefinitionModel;
  @Input() objectDefinition: ObjectDefinitionModel;
  @Output() filterChange: EventEmitter<ExpenseUpdateModalHeader> =
    new EventEmitter<ExpenseUpdateModalHeader>();
  type: ExpenseEventType;
  data: ExpenseModel = null;

  constructor() {
    this.type = ExpenseEventType.Add;
  }

  openExpenseDialog() {
    const seedData = this._objectDefinitionHelpers.getSeedData(
      this.parentDefinition?.systemCode,
      this.objectDefinition?.addConfig
    );

    this._objectDefinitionHelpers
      .applySeedData(this.parent, new ExpenseModel(), seedData)
      .subscribe((newExpenseModel) => {
        const portCallFileField = ObjectDefinitionModel.getAllFieldDefinitions(
          this.objectDefinition
        ).find(
          (x) =>
            x.additionalDataModel?.mappingKey?.toLowerCase() ===
            '$customcontent_portcallfile___id'
        );

        const modal = this._modal.open(this._exprenseCreateModal, {
          backdrop: 'static',
        });
        if (
          portCallFileField &&
          newExpenseModel[portCallFileField.systemCode]
        ) {
          modal.componentInstance.loadingOrderRegistrations = true;
          this._customDataContentService
            .searchDataByObjectKeyAndFields(
              {
                Scope: 'system',
                SystemCode: 'orderRegistration',
              },
              [
                {
                  fieldName: 'portCallFile',
                  searchOperator: SearchOperators.Equals,
                  searchValue: newExpenseModel[portCallFileField.systemCode],
                  searchColumn: 'portCallFile',
                },
              ],
              ['Active']
            )
            .subscribe((result) => {
              modal.componentInstance.loadingOrderRegistrations = false;
              if (result && result.status === ResultStatus.OK) {
                modal.componentInstance.orderRegistrations = result.result;
              }
            });
        }

        modal.componentInstance.expense = newExpenseModel;
        modal.componentInstance.newExpense = true;
        modal.result.then((event: EventModel) => {
          if (event.data) {
            this.data = event.data;
            this.raiseEvent();
          }
        });
      });
  }

  raiseEvent() {
    this.filterChange.emit(this);
  }
}
